import styled from 'styled-components'

export const Wrapper = styled.div`
  width: ${({ isCourseContent, isOnboarding }) =>
    (!isCourseContent && !isOnboarding)
      ? 'clamp(300px, 80vw, 800px)'
      : '100%'};

  height: ${({ isCourseContent, isOnboarding }) => {
    if (!isCourseContent && !isOnboarding) {
      return 'clamp(400px, 70vh, 600px)';
    }
    if (isCourseContent && !isOnboarding) {
      return '505px';
    }
    return '600px';
  }};

  background: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  box-shadow: ${({ isOnboarding }) =>
    !isOnboarding ? '0 4px 14px rgba(0, 0, 0, .15)' : 'none'};
  margin: auto;
`






export const Header = styled.header`
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  font: 500 16px 'Inter', sans-serif;
  color:rgb(20, 20, 22);
  display: flex;
  align-items: center;
  gap: 6px;
`

export const Body = styled.main`
  flex: 1;
  overflow-y: auto;
  padding: 90px 90px;
  display: flex;
  flex-direction: column;
  justify-content: center;   
  align-items: center;      
  text-align: center;
  gap: 24px;
`

export const Footer = styled.footer`
  padding: 8px 16px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  font-size: 14px;

  button {
    background: none;
    border: none;
    color: #2563eb;
    cursor: pointer;
  }
  button:disabled {
    color: #9ca3af;
    cursor: not-allowed;
  }
`

export const Title = styled.h4`
  font: 600 20px/1.3 'Inter', sans-serif;
  color: #1f2937;
  margin: 0;
  text-align: center;              /* ⬅ centraliza título */
`

export const Sub = styled.p`
  font: 14px/1.4 'Inter', sans-serif;
  color: #6b7280;
  margin: 0;
  margin-top: -7px;
  text-align: center;              /* ⬅ centraliza subtítulo */
`

export const Ctrl = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const NavButton = styled.button`
  background: none;
  border: none;
  font: inherit;
  color:#28AAE1 !important;  
  cursor: pointer;
  transition: opacity .15s;
  &:hover:not(:disabled) { opacity: .8; }
  &:disabled {
   color:#9ca3af !important;       
   cursor: not-allowed;
 }
   `